<template>
  <div class="t">
    <span class="t-tip1">
      <iconpark-icon name="saomadenglu"></iconpark-icon>
    </span>
    <div class="t-icon" @click="handleClick">
      <iconpark-icon name="QRcode"></iconpark-icon>
    </div>
    <div class="t-form">
      <p class="t-title">
        <span @click="formClick" :class="`${formKey === 'FormEmailComponent'&&'t-title-active'}`">邮箱登录</span>
        <span @click="formClick" :class="`${formKey === 'FormPhoneComponent'&&'t-title-active'}`">手机验证码</span>
      </p>
      <div class="t-form-content">
        <component :is="formKeyComponent"></component>
      </div>
    </div>
    <a-divider class="t-tip2">
      <span class="t-tip2-span">第三方账号登录</span>
    </a-divider>
    <div class="footer-icon">
      <iconpark-icon @click="loginWithAuthData('weixin')" class="icon" name="wechatnormal1"></iconpark-icon>
      <!-- <iconpark-icon @click="loginWithAuthData('apple')" class="icon" name="applenormal2"></iconpark-icon> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Password',
  data() {
    return {
      formKey: 'FormPhoneComponent',
      isEmail: true,
    }
  },
  methods: {
    handleClick() {
      this.$emit('handleClick', 'QrcodeComponent')
    },
    formClick() {
      this.formKey =
        this.formKey === 'FormEmailComponent'
          ? 'FormPhoneComponent'
          : 'FormEmailComponent'
    },

    loginWithAuthData(type) {
      if (type === 'weixin') {
        window.location.href =
          'https://open.weixin.qq.com/connect/qrconnect?appid=wx250b1549d72d6ffd&redirect_uri=https%3A%2F%2Fg.moshouapp.cn%2F%23%2Flogin&response_type=code&scope=snsapi_login'
      }
    },
  },
  computed: {
    formKeyComponent: function () {
      return this.formKey
    },
  },
  components: {
    FormEmailComponent: () => import('./FormEmail.vue'),
    FormPhoneComponent: () => import('./FormPhone.vue'),
  },
}
</script>
<style scoped lang="less">
.t {
  &-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
    top: 10px;
    font-size: 60px;
  }
  &-tip1 {
    position: absolute;
    right: 75px;
    font-size: 72px;
    top: -22px;
  }
  &-tip2::before {
    transform: translateY(0%) !important;
  }
  &-tip2::after {
    transform: translateY(0%) !important;
  }
  &-tip2 {
    &-span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #aaaaaa;
      line-height: 18px;
      letter-spacing: 1px;
    }
  }
  &-title {
    margin-bottom: 28px;
    &-active {
      color: #ffb547 !important;
      border-bottom: 1px solid #ffb547;
    }
    span {
      font-size: 16px;
      margin-right: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #aaaaaa;
      line-height: 22px;
      cursor: pointer;
    }
  }
  .footer-icon {
    text-align: center;
    .icon {
      font-size: 36px;
      margin: 0 15px;
    }
  }
}
</style>
